import React from "react";
import PlanRow from "./PlanRow";

function PlanTable({ 
  navlog = [], 
  onEdit, 
  onAddRow, 
  onDeleteRow,
  stationList = [], 
}) {
  console.log("----------PlanTable function LOADED");

  return (
    <div style={{ marginBottom: "8px" }}>
      
      {/* Header + Add Row Button */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "14px",
          marginBottom: "4px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}>
 
        <button
          type="button"
          onClick={onAddRow}
          style={{
            padding: "8px 14px",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          + Add NAVLOG Row
        </button>
        {/* text */}
        <span
          style={{
            fontWeight: "bold",
            fontSize: "20px",
            color: "#0d0d0d",
            marginTop: "6px",
          }}
        >
          add legs for each checkpoint along the route
        </span>
        <div 
          style={{ 
            marginTop: "4px",
            marginLeft: "0px",
            fontSize: "18px" ,
            fontWeight: "bold",
            color: "#333"
            }}>
          wind decoded example: 810543: 81-50=31 &rarr; 310°; 05: 100+05=105kts; 43: -43°C
          </div>
        </div>
         <br></br>
      </div>
        <p
        style={{
          fontSize: "14px",
          marginBottom: "8px",
          color: "#555",
          textAlign: "left",
          }}>
            <br></br>
            In the Navlog table below:
            <br></br>
            Headwind (HW): '+' is a headwind, '-' is a tailwind. 
            <br></br>
            Crosswind (CW): '+' is a right crosswind, '-' is a left crosswind.
               
        </p>
      {/* Nav Log Table */}
      <table
        id="navlogx">
          <caption className="caption_navlog">NAVLOG</caption>
          
        <thead>
          <tr>
            <th className="navlog-ft-col">FT</th>
            <th className="navlog-checkpoint-col">Checkpoint</th>
            <th className="navlog-cruisealt-col">CruiseAlt</th>
            <th className="navlog-cas-col">CAS</th>
            <th className="navlog-tc-col">TC</th>
            <th className="navlog-nm-col">NM</th>
            <th className="navlog-gph-col">GPH</th>
            <th className="navlog-mdev-col">Mvar</th>
            <th className="navlog-cdev-col">Cdev</th>

            <th className="navlog-tas-col">TAS</th>
            <th className="navlog-wind-col">Wind intrp</th>

            <th className="navlog-wca-col">WCA</th>
            <th className="navlog-th-col">TH</th>
            
            <th className="navlog-ch-col">CH</th>
            
            <th className="navlog-gs-col">GS</th>
            <th className="navlog-ete-col">ETE</th>
            <th className="navlog-gal-col">GALs</th>
            <th className="navlog-hw-col">HW</th>
            <th className="navlog-cw-col">CW</th>
            <th className="navlog-delete-col"></th>
          </tr>
        </thead>

        <tbody>
          {navlog.map((leg, i) => (
            <PlanRow
              key={i}
              plan={leg}
              index={i}
              onEdit={onEdit}
              onDelete={onDeleteRow}
              disableDelete={navlog.length <= 1}
              stationList={stationList}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default PlanTable;